(function(){
    'use strict';

    var forms = {};

    forms.init = function() {
        document.querySelectorAll('form[data-validate="true"]').forEach(form => {
            // Add event listeners for real-time validation
            form.querySelectorAll('[data-validate-required]').forEach(input => {
                input.addEventListener('input', () => validateRequired(input));
            });

            form.querySelectorAll('[data-validate-email]').forEach(input => {
                input.addEventListener('input', () => validateEmail(input));
            });

            form.querySelectorAll('[data-validate-numeric]').forEach(input => {
                input.addEventListener('input', () => validateNumeric(input));
            });

            form.querySelectorAll('[data-validate-filetype]').forEach(input => {
                input.addEventListener('change', () => validateFileType(input));
            });

            form.querySelectorAll('[data-validate-filesize]').forEach(input => {
                input.addEventListener('change', () => validateFileSize(input));
            });

            form.querySelectorAll('[data-validate-regex]').forEach(input => {
                input.addEventListener('input', () => validateRegex(input));
            });

            form.querySelectorAll('[data-validate-length]').forEach(input => {
                input.addEventListener('input', () => validateLength(input));
            });

            // Prevent form submission if any field is invalid
            form.addEventListener('submit', function(event) {
                let valid = true;

                form.querySelectorAll('.sq-form-error').forEach(errorElement => {
                    errorElement.remove();
                });

                form.querySelectorAll(':not(input[type=radio],input[type=checkbox])[data-validate-required]').forEach(input => {
                    if (!validateRequired(input)) valid = false;
                });

                form.querySelectorAll('.sq-form-question-option-list li:first-child input[type=radio][data-validate-required], .sq-form-question-tickbox-list li:first-child input[type=checkbox][data-validate-required]').forEach(input => {
                    if (!validateRequiredRadio(input)) valid = false;
                });

                form.querySelectorAll('[data-validate-email]').forEach(input => {
                    if (!validateEmail(input)) valid = false;
                });

                form.querySelectorAll('[data-validate-numeric]').forEach(input => {
                    if (!validateNumeric(input)) valid = false;
                });

                form.querySelectorAll('[data-validate-filetype]').forEach(input => {
                    if (!validateFileType(input)) valid = false;
                });

                form.querySelectorAll('[data-validate-filesize]').forEach(input => {
                    if (!validateFileSize(input)) valid = false;
                });

                form.querySelectorAll('[data-validate-regex]').forEach(input => {
                    if (!validateRegex(input)) valid = false;
                });

                form.querySelectorAll('[data-validate-length]').forEach(input => {
                    if (!validateLength(input)) valid = false;
                });

                if (!valid) {
                    event.preventDefault();
                    scrollToFirstError(form);
                }
            });
        });
    };

    function validateRequired(input) {
        removeErrorMessage(input, 'required-error');
        if (!input.checked && !input.value.trim()) {
            const errorMessage = input.getAttribute('data-validate-required');
            appendErrorMessage(input, errorMessage, 'required-error');
            return false;
        }
        return true;
    }

    function validateRequiredRadio(input) {
        removeErrorMessage(input, 'required-error');
        const checkedRadio = input.closest('.sq-form-question-answer').querySelectorAll('input[type=radio]:checked');
        if (!checkedRadio.length) {
            const errorMessage = input.getAttribute('data-validate-required');
            appendErrorMessage(input, errorMessage, 'required-error');
            return false;
        }
        return true;
    }

    function validateEmail(input) {
        const errorMessage = input.getAttribute('data-validate-email');
        removeErrorMessage(input, 'email-error');
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (input.value.trim() && !emailRegex.test(input.value.trim())) {
            appendErrorMessage(input, errorMessage, 'email-error');
            return false;
        }
        return true;
    }

    function validateNumeric(input) {
        const errorMessage = input.getAttribute('data-validate-numeric');
        removeErrorMessage(input, 'numeric-error');
        if (input.value.trim() && isNaN(input.value.trim())) {
            appendErrorMessage(input, errorMessage, 'numeric-error');
            return false;
        }
        return true;
    }

    function validateFileType(input) {
        const errorMessage = input.getAttribute('data-validate-filetype');
        const allowedTypes = input.getAttribute('data-validate-filetype-rule').replace(/[\[\]]/g, '').split(',').map(type => type.trim());
        removeErrorMessage(input, 'filetype-error');
        const fileNameParts = input.files[0].name.split('.');
        const fileExtension = fileNameParts.length > 1 ? fileNameParts.pop() : "";
        if (input.files[0] && !allowedTypes.includes(fileExtension)) {
            appendErrorMessage(input, errorMessage, 'filetype-error');
            return false;
        }
        return true;
    }

    function validateFileSize(input) {
        const errorMessage = input.getAttribute('data-validate-filesize');
        const maxSize = parseInt(input.getAttribute('data-validate-filesize-rule')) * 1024 * 1024;
        removeErrorMessage(input, 'filesize-error');
        const file = input.files[0];
        if (file && file.size > maxSize) {
            appendErrorMessage(input, errorMessage, 'filesize-error');
            return false;
        }
        return true;
    }

    function validateRegex(input) {
        const errorMessage = input.getAttribute('data-validate-regex');
        const regexPattern = input.getAttribute('data-validate-regex-rule');
        
        const regex = new RegExp(regexPattern);
        removeErrorMessage(input, 'regex-error');
        if (input.value.trim() && !regex.test(input.value.trim())) {
            appendErrorMessage(input, errorMessage, 'regex-error');
            return false;
        }
        return true;
    }

    function validateLength(input) {
        const errorMessage = input.getAttribute('data-validate-length');
        const requiredLength = parseInt(input.getAttribute('data-validate-length-rule'));
        removeErrorMessage(input, 'length-error');
        if (input.value.trim() && input.value.trim().length !== requiredLength) {
            appendErrorMessage(input, errorMessage, 'length-error');
            return false;
        }
        return true;
    }

    function appendErrorMessage(input, message, errorClass) {
        // Remove any existing error message of the same type
        removeErrorMessage(input, errorClass);
    
        // Create and append the new error message
        const errorElement = document.createElement('p');
        errorElement.className = `sq-form-error ${errorClass}`;
        errorElement.textContent = message;
        input.closest('.sq-form-question').querySelector('.sq-form-question-answer').after(errorElement);
    
        // Add error class to the question div
        input.closest('.sq-form-question').classList.add('sq-form-question-error');
    }
    
    function removeErrorMessage(input, errorClass) {
        const container = input.closest('.sq-form-question');
        const errorElement = container.querySelector(`.${errorClass}`);
        if (errorElement) {
            errorElement.remove();
            // Check if there are no more errors and remove the error class
            if (container.querySelectorAll('.sq-form-error').length === 0) {
                container.classList.remove('sq-form-question-error');
            }
        }
    }

    function scrollToFirstError(form) {
        const firstError = form.querySelector('.sq-form-question-error');
        if (firstError) {
            firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }

    // Make forms available to public
    QLD.forms = forms;
    
    document.addEventListener("DOMContentLoaded", function(event) { 
        if (document.querySelector(`form[data-validate="true"]`)) {
            QLD.forms.init();
        }
    });
    
}());